<div class="card-content" style="padding: 12px">
  <h5 class="label">Mes Commandes</h5>

  <div>
    <div *ngIf="currentState === State.LOADING" class="loading-container">
      <nz-spin nzTip="Chargement des livraisons..."></nz-spin>
    </div>

    <div *ngIf="currentState === State.ERROR" class="error-container">
      <nz-result nzStatus="warning" nzTitle="Aucune livraison trouvée">
        <p>Nous n'avons trouvé aucun historique de livraisons</p>
      </nz-result>
    </div>

    <!-- Table pour les écrans larges -->
    <nz-table
      *ngIf="currentState === State.SUCCESS"
      #deliveryTable
      [nzBordered]="true"
      [nzData]="deliveries"
      [nzShowPagination]="false"
      [nzHoverable]="true"
      class="desktop-view"
    >
      <thead>
        <tr>
          <th nzWidth="5%" class="center">Date</th>
          <th nzWidth="5%" class="center">Type</th>
          <th nzWidth="100%" class="center">Produits</th>
          <th nzWidth="5%" class="center">Statut</th>
          <th nzWidth="5%" class="center">Suivi</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let delivery of deliveries" class="delivery-row">
          <td class="center">
            {{ delivery.createdDate | date: 'dd/MM/yyyy' }}
          </td>

          <td class="center">
            <nz-tag [nzColor]="getDeliveryTypeTag(delivery.deliveryType).color">
              {{ getDeliveryTypeTag(delivery.deliveryType).text }}
            </nz-tag>
          </td>

          <td class="center">
            <nz-list [nzBordered]="false" class="product-list">
              <nz-list-item *ngFor="let product of delivery.products" [nzPadding]="{ top: 8, bottom: 8 }">
                {{ getProductLabel(product.productType) }} x {{ product.quantity }}
              </nz-list-item>
            </nz-list>
          </td>

          <td class="center">
            <nz-tag [nzColor]="getDeliveryStatusTag(delivery.status).color">
              {{ getDeliveryStatusTag(delivery.status).text }}
            </nz-tag>
          </td>

          <td class="center">
            <a
              *ngIf="delivery.trackingNumber"
              class="tracking-link"
              href="https://www.laposte.fr/outils/suivre-vos-envois?code={{ delivery.trackingNumber }}"
              target="_blank"
            >
              <i nz-icon nzType="link" nzTheme="outline"></i> Suivre
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <div *ngIf="currentState === State.SUCCESS" class="mobile-view">
      <nz-card *ngFor="let delivery of deliveries" class="delivery-card">
        <p><strong>Date :</strong> {{ delivery.createdDate | date: 'dd/MM/yyyy' }}</p>

        <p>
          <strong>Type : </strong>
          <nz-tag [nzColor]="getDeliveryTypeTag(delivery.deliveryType).color">
            {{ getDeliveryTypeTag(delivery.deliveryType).text }}
          </nz-tag>
        </p>

        <span><strong>Produits :</strong></span>
        <ul class="product-list">
          <li *ngFor="let product of delivery.products">
            {{ getProductLabel(product.productType) }} x {{ product.quantity }}
          </li>
        </ul>

        <p>
          <strong>Statut : </strong>
          <nz-tag [nzColor]="getDeliveryStatusTag(delivery.status).color">
            {{ getDeliveryStatusTag(delivery.status).text }}
          </nz-tag>
        </p>

        <p *ngIf="delivery.trackingNumber">
          <a
            class="tracking-link"
            href="https://www.laposte.fr/outils/suivre-vos-envois?code={{ delivery.trackingNumber }}"
            target="_blank"
          >
            <i nz-icon nzType="link" nzTheme="outline"></i> Suivre la commande
          </a>
        </p>
      </nz-card>
    </div>
  </div>
</div>
